import styled from "styled-components";

export const LabelText = styled.p`
	margin: 0.4rem 0 0;
	color: ${({ theme }) => theme.icon};
`;
interface ILinkTextProps {
	$isDisabled?: boolean;
}
export const LinkText = styled.span<ILinkTextProps>`
	color: ${({ theme }) => theme.icon};
	font-weight: bold;
	opacity: ${(prop) => (prop.$isDisabled ? 0.7 : 1)};

	&:hover {
		cursor: ${(prop) => (prop.$isDisabled ? "default" : "pointer")};
		text-decoration: ${(prop) => (prop.$isDisabled ? "none" : "underline")};
	}
`;
